<ng-container *ngIf="show">
  <!-- Inline spinner (no overlay) -->
  <div *ngIf="inline" class="spinner inline" [class.dark]="dark">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>

  <!-- Full / partial overlay spinner -->
  <div
    *ngIf="!inline"
    class="full-overlay"
    [class.full-overlay]="!partial"
    [class.partial-overlay]="partial"
    [class.dark]="dark"
  >
    <div *ngIf="!!showTextLoader" class="loading-container">
      <div class="loading-text">
        {{ displayText }}
      </div>
    </div>
    <div class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
</ng-container>
